import { Grid } from "@mui/material";
import { SelectInput, TextInput, required } from "react-admin";
import { GenderOptionsId } from "utils/choices";
import { nameCyrillicRegexValidator } from "utils/validations";

const PersonalInfoSection = () => (
  <Grid container spacing={2}>
    <Grid item xs={12} md={4}>
      <TextInput
        source="firstName"
        label="Име"
        validate={[required("Задължително"), nameCyrillicRegexValidator]}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput source="secondName" label="Презиме" validate={nameCyrillicRegexValidator} fullWidth />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput
        source="lastName"
        label="Фамилия"
        validate={[required("Задължително"), nameCyrillicRegexValidator]}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <SelectInput source="gender" label="Пол" choices={GenderOptionsId} fullWidth />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput source="contactPhone" label="Телефон за връзка" fullWidth />
    </Grid>
  </Grid>
);

export default PersonalInfoSection;
